import { TagsFilterParams } from '../services/tags/tags.model';
import { ArticleTableRow } from './ArticleTableRow';

export enum TopReadsRange {
  DAY = '24Hrs',
  WEEK = '7Days',
  MONTH = '30Days',
}

export interface TopReadsResponse {
  [TopReadsRange.DAY]: ArticleTableRow[];
  [TopReadsRange.WEEK]: ArticleTableRow[];
  [TopReadsRange.MONTH]: ArticleTableRow[];
}

export interface TopReadsQueryParams {
  myCS: boolean;
  tags?: TagsFilterParams;
  textContains?: string;
  startDate?: Date;
  endDate?: Date;
}
